import { render, staticRenderFns } from "./DStatsCheese.vue?vue&type=template&id=3a842cbc&"
import script from "./DStatsCheese.vue?vue&type=script&lang=js&"
export * from "./DStatsCheese.vue?vue&type=script&lang=js&"
import style0 from "./DStatsCheese.vue?vue&type=style&index=0&id=3a842cbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports